import React from 'react';
import { Dialog, DialogTitle, List, ListItem, ListItemText } from '@mui/material';
import { Agency } from './admin/AgencyManagementPage';

interface AgencySelectorModalProps {
    open: boolean;
    onClose: () => void;
    agencies: Agency[];
    onSelect: (ori: string) => void;
}

const AgencySelectorModal: React.FC<AgencySelectorModalProps> = ({ open, onClose, agencies, onSelect }) => {
    const handleSelect = (ori: string) => {
        onSelect(ori);
        onClose();
    };

    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>Select an Agency</DialogTitle>
            <List sx={{ pt: 0 }}>
                {agencies.map((agency) => (
                    <ListItem button onClick={() => handleSelect(agency.ori)} key={agency.ori}>
                        <ListItemText primary={agency.name} secondary={agency.ori} />
                    </ListItem>
                ))}
            </List>
        </Dialog>
    );
};

export default AgencySelectorModal;
